import React, { type Ref, useEffect } from 'react';

import Button from '@atlaskit/button/default/button';
import { FlagsProvider } from '@atlaskit/flag/flags-provider';
import { useFlags } from '@atlaskit/flag/use-flags';
import { initEntryPointConfig } from '@atlassian/entry-point-config/init-entry-point-config';
import type { ModalErrorFallbackProps } from '@atlassian/entry-point-config/types';
import { ModalContextProvider } from '@atlassian/entry-points/modal-context-provider';
import { ModalTrigger } from '@atlassian/entry-points/modal-trigger';

import { errorModalEntryPoint } from '../fixtures/legacy/errorModal.entrypoint';
import { RelayWrapper } from '../utils/wrapper';

function CustomModalError({ closeModal }: ModalErrorFallbackProps): React.JSX.Element | null {
	const { showFlag } = useFlags();

	useEffect(() => {
		showFlag({
			title: 'Modal content is unavailable',
			description: 'This example failed on purpose. Try again later.',
		});
		closeModal();
	}, [closeModal, showFlag]);

	return null;
}

initEntryPointConfig({
	GlobalModalErrorFallback: CustomModalError,
});

export default function ModalTriggerCustomError(): React.JSX.Element {
	return (
		<FlagsProvider>
			<RelayWrapper>
				<ModalContextProvider>
					<ModalTrigger entryPoint={errorModalEntryPoint}>
						{({ ref }) => (
							<Button ref={ref as Ref<HTMLButtonElement>} aria-haspopup="dialog">
								Show custom error
							</Button>
						)}
					</ModalTrigger>
				</ModalContextProvider>
			</RelayWrapper>
		</FlagsProvider>
	);
}
